<template>
<span>

    <v-toolbar flat color="white">
        <v-toolbar-title class="lime--text lighten-1">Gerenciar Medidas </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="blue-grey darken-2" dark class="mb-1" @click.prevent="atualizaDados">
                <v-icon dark>sync</v-icon>Atualizar
            </v-btn>
            <v-btn color="success" dark class="mb-1 ml-2" :to="{name: 'product-measure.add'}">Adicionar Nova Medida</v-btn>
        </template>
    </v-toolbar>

    <v-card>
        <v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Localizar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="loadProductMeasures" :search="search" :rowsPerPageItems="rowsPerPageItems">

            <template v-slot:[`item.prod_me_status`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.prod_me_status" @change="onChangeEventHandlerStatus(item.prod_me_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

             <template v-slot:[`item.acoes`]="{ item }">
                <v-tooltip top color="blue white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="blue lighten-1" @click.prevent="editProductMeasure(item)" v-on="on">
                            <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>

                <v-tooltip top color="red white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="red lighten-1" @click.prevent="deleteProductMeasure(item)" v-on="on">
                            <v-icon dark class="mdi mdi-delete"></v-icon>
                        </v-btn>
                    </template>
                    <span>Excluir</span>
                </v-tooltip>
            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Voce procurou por "{{ search }}" nenhum item localizado.
                </v-alert>
            </template>
        </v-data-table>
    </v-card>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../config/configs'

export default {
    name: "ProductMeasureComponent",
    created() {
        this.$store.dispatch('loadProductMeasures');
    },
    computed: {
        loadProductMeasures() {
            if (this.$store.state.productmeasures.items.data == null)
                return []

            return this.$store.state.productmeasures.items.data;
        }
    },
    data() {
        return {
            search: '',
            rowsPerPageItems: [10, 20, 30, {
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "10": -1
            }],
            headers: [{
                    sortable: false,
                    text: 'Nome',
                    value: 'prod_me_nome'
                },
                {
                    sortable: false,
                    text: 'Abrev',
                    value: 'prod_me_abrev'
                },
                {
                    sortable: false,
                    text: 'Status',
                    value: 'prod_me_status'
                },
                {
                    text: 'Ações',
                    align: 'center',
                    sortable: false,
                    value: 'acoes'
                }
            ],
            productmeasure: [],
            base_url: URL_BASE
        }
    },
    methods: {
        atualizaDados() {
            this.$store.dispatch('loadProductMeasures');
        },
        editProductMeasure(item) {
            this.$router.push({
                name: 'product-measure.edit',
                params: {
                    prod_me_id: item.prod_me_id
                }
            });
        },
        detailProductMeasure(item) {
            this.$router.push({
                name: 'product-measure.detail',
                params: {
                    prod_me_id: item.prod_me_id
                }
            });
        },
        deleteProductMeasure(item) {
            this.$swal({
                title: 'Você tem certeza?',
                text: "Você não poderá reverter isso",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D32F2F',
                cancelButtonColor: '#1976D2',
                confirmButtonText: 'Sim, Exclua!'
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('destroyProductMeasure', item.prod_me_id)
                        .then(response => {
                            if (response) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: 'Sucesso',
                                    text: 'Dados excluídos com sucesso',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                                this.atualizaDados();
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: 'Opssss!',
                                    text: 'Erro ao excluir dados',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: 'Opssss!',
                                text: 'Algo errado aconteceu!',
                                showConfirmButton: true,
                                timer: 6000
                            });
                        })
                }
            })
        },
        onChangeEventHandlerStatus(prod_me_id, value) {
            this.$store.dispatch('updateProductMeasureStatus', {
                    prod_me_id: prod_me_id,
                    prod_me_status: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: 'Sucesso',
                        text: 'Status do Status atualizado com sucesso',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Opssss!',
                        text: 'Erro ao atualizar status do Status',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {

    }
};
</script>

<style scoped>
.avatar {
    height: 40px;
    margin-top: 0.4rem;
}
</style>
